module.exports = __webpack_public_path__ + "img/dot_yellow.b113e23d.png";